<template>
  <div class="platform_view_container">
    <component
        v-if="pathName"
        :is="navigation[pathName]"
    />
    <div :class="navigation[pathName] ? 'container' : 'platform_view_container'">
      <Header
          :hamburgerProps="!!navigation[pathName]"
      />
      <router-view/>
    </div>
    <CountryNotice />
  </div>
</template>
<script>
import MyPatientNav from '@/components/nav/myPatient';
import OptionNav from '@/components/nav/optionDashboard';
import {mapActions} from "vuex";

export default {
  components: {
    Header: () => import('@/components/header/index'),
    CountryNotice: () => import('@/components/common/CountryNotice'),
  },
  data() {
    return {
      pathName: '',
      navigation: {
        details: MyPatientNav,
        options: OptionNav
      }
    }
  },
  watch: {
    $route: {
      deep: true,
      handler(newVal) {
        this.changeNavigation(newVal.path);
      }
    }
  },
  created() {
    this.changeNavigation(this.$route.path);

    const token = localStorage.getItem('accessToken');
    if (token) {
      this.changeAuth({
        seqUser: localStorage.getItem('seqUser'),
        seqManager: localStorage.getItem('seqManager'),
        userEmail: localStorage.getItem('userEmail'),
        userName: localStorage.getItem('userName'),
        accessToken: token,
        //refreshToken: res.data.token.refreshToken,
        isAuth: true,
      });
    }
  },
  methods: {
    ...mapActions(['changeAuth']),
    changeNavigation(path) {
      let pathName;
      const newParentPath = path.split('/');

      if (newParentPath.includes('details')) {
        pathName = 'details';
      } else if (newParentPath.includes('rehab')) {
        pathName = 'rehab';
      } else if (newParentPath.includes('options')) {
        pathName = 'options';
      }
      this.pathName = pathName;
    }
  }
}
</script>
<style>
  .platform_view_container {
    width: 100vw;
    min-width: 1024px;
  }
</style>